export default {
	idFornecedor: null,
	idPessoaNova: null,
	justificativa: null,
}
